/*
 * @Author: 窦云飞 df1987131@yeah.net
 * @Date: 2023-02-21 13:39:38
 * @LastEditors: 窦云飞 df1987131@yeah.net
 * @LastEditTime: 2023-02-21 13:40:47
 * @FilePath: /epec-bidding/Users/douyunfei/Documents/epec-ea/src/directive copy/permission/index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import store from "../../modules/projectA/store";

export default {
  inserted(el, binding) {
    let permissions = store.state.buttonDirective;
    setTimeout(() => {
      const {
        value
      } = binding;
      permissions = store.state.buttonDirective;
      if (value && value instanceof Array && value.length > 0) {
        const permissionRoles = value;
        const hasPermission = permissions && permissions.some(item => {
          return permissionRoles.includes(item.authCode);
        });

        if (!hasPermission) {
          el.parentNode && el.parentNode.removeChild(el);
        }
      } else {
        throw new Error("需要的权限! 像v-permission = ['admin','editor']");
      }
    },100)
  }
};
